import { render } from "./SearchSwitcherSemanticIcon.vue?vue&type=template&id=08d9ff6c"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__